import React from 'react';
import { Institution } from '../../types/institution';
import { getBankLogo } from '../../utils/bankAssets';
import './BankSearchResult.css';

export interface BankSearchResultProps {
  institution: Institution;
  showDivider?: boolean;
  onClick?: (institution: Institution) => void;
}

const BankSearchResult: React.FC<BankSearchResultProps> = ({
  institution,
  showDivider = false,
  onClick
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(institution);
    }
  };

  // Use branding.icon for search results, fallback to logo, then default
  const iconUrl = institution.branding?.icon ||
    institution.branding?.logo ||
    getBankLogo(institution.name.toLowerCase()) ||
    getBankLogo('default');

  return (
    <div className="bank-search-result" onClick={handleClick}>
      <div className="result-bank-info">
        <div
          className="result-bank-icon"
          style={{ backgroundColor: institution.branding?.primary_color || '#1a365d' }}
        >
          <img
            src={iconUrl}
            alt={institution.name}
            onError={(e) => {
              (e.target as HTMLImageElement).src = getBankLogo('default');
            }}
          />
        </div>
        <span className="result-bank-name">{institution.name}</span>
      </div>
      {showDivider && <div className="result-divider"></div>}
    </div>
  );
};

export default BankSearchResult; 